import { ADOBE_DATA_LAYER_URL } from "../config";
import { getSettings } from "../utils/helper";

interface MetricsWindow {
  dataLayerArray?: any[];
}

const pushLayer = (window: MetricsWindow, metric: any) => {
  if (process.env.NODE_ENV === "development") {
    console.log(metric);
  }
  window.dataLayerArray = window.dataLayerArray || [];
  window.dataLayerArray.push(metric);
};

export async function loadAdobeScript() {
  if (!window.adobeScriptLoaded) {
    getSettings().then((settings) => {
      const script = document.createElement("script");
      script.setAttribute("src", ADOBE_DATA_LAYER_URL[settings.stage]);
      script.setAttribute("defer", "");
      script.setAttribute("async", "");
      document.body.appendChild(script);
    });
    window.adobeScriptLoaded = true;
  }
}

export async function sendMetrics(metric) {
  try {
    await loadAdobeScript();
    pushLayer(window, metric);
  } catch (err) {
    console.log(`Failed to send adobe metrics, error details: ${err}`);
  }
}
